<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group" transform="translate(2, 2)">
        <polygon id="Path" points="0 0 20 0 20 20 0 20"></polygon>
        <path
          id="Path"
          d="M13.3333333,6.5 C13.8856181,6.5 14.3333333,6.94771525 14.3333333,7.5 C14.3333333,8.05228475 13.8856181,8.5 13.3333333,8.5 L6.66666667,8.5 C6.11438192,8.5 5.66666667,8.05228475 5.66666667,7.5 C5.66666667,6.94771525 6.11438192,6.5 6.66666667,6.5 L13.3333333,6.5 Z"
          fill="#4A154B"
          fill-rule="nonzero"
        ></path>
        <path
          id="Path"
          d="M11.6666667,9.83333333 C12.2189514,9.83333333 12.6666667,10.2810486 12.6666667,10.8333333 C12.6666667,11.3856181 12.2189514,11.8333333 11.6666667,11.8333333 L6.66666667,11.8333333 C6.11438192,11.8333333 5.66666667,11.3856181 5.66666667,10.8333333 C5.66666667,10.2810486 6.11438192,9.83333333 6.66666667,9.83333333 L11.6666667,9.83333333 Z"
          fill="#4A154B"
          fill-rule="nonzero"
        ></path>
        <path
          id="Path"
          d="M15,2.5 C16.8409492,2.5 18.3333333,3.99238417 18.3333333,5.83333333 L18.3333333,12.5 C18.3333333,14.3409492 16.8409492,15.8333333 15,15.8333333 L12.845,15.8333333 L10.5892557,18.0892557 C10.2888523,18.389659 9.8161598,18.4127669 9.48925046,18.1585795 L9.41074435,18.0892557 L7.15416667,15.8333333 L5,15.8333333 C3.21483717,15.8333333 1.75743427,14.4300263 1.67074609,12.666367 L1.66666667,12.5 L1.66666667,5.83333333 C1.66666667,3.99238417 3.15905083,2.5 5,2.5 L15,2.5 Z M15,4.16666667 L5,4.16666667 C4.07952542,4.16666667 3.33333333,4.91285875 3.33333333,5.83333333 L3.33333333,12.5 C3.33333333,13.4204746 4.07952542,14.1666667 5,14.1666667 L7.5,14.1666667 C7.72101374,14.1666667 7.93297534,14.254464 8.08925565,14.4107443 L10,16.3208333 L11.9107443,14.4107443 C12.0409779,14.2805108 12.2098791,14.1978348 12.3904634,14.1738937 L12.5,14.1666667 L15,14.1666667 C15.9204746,14.1666667 16.6666667,13.4204746 16.6666667,12.5 L16.6666667,5.83333333 C16.6666667,4.91285875 15.9204746,4.16666667 15,4.16666667 Z"
          fill="#4A154B"
          fill-rule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
</template>
